module.exports = __webpack_public_path__ + "static/media/1_08.aeef24ac.jpg";